export default {
  nav: {
    portfolio: "Widyo's Portfolio",
    whyme: "Why Me?",
    education: "Education",
    experience: "Experience",
    organizational: "Organizational",
    events: "Events",
    portfolio_link: "Portfolio",
    skills: "Skills",
    certificates: "Certificates",
    awards: "Awards",
    contact: "Contact",
    downloadResume: "Download Resume",
    downloadPortfolio: "Download Portfolio",
    letsConnect: "Let's Connect",
  },
  hero: {
    greeting: "Hello!",
    name: "I'm Widyo Tri Cahya Utomo",
    nickname: "Dio",
    title: "DevOps Engineer | Data Engineer",
    description: "DevOps Engineer at Apple Developer Institute, automating AWS infrastructure as code with Terraform and Ansible and building CI/CD pipelines. Backed by three years of enterprise data engineering — ETL/CDC, cloud migrations, and data platforms.",
    downloadResume: "Download Resume",
    contactMe: "Contact Me",
  },
  whyme: {
    title: "Why Me?",
    subtitle: "What makes me different as a DevOps Engineer",
    content: "I don't just move data — I turn it into intelligence that creates real business value. I approach every problem with curious skepticism, validating assumptions and engineering systems that scale, stay reliable, and actually deliver outcomes. My experience spans end-to-end data engineering, including ingestion, warehousing, orchestration, governance, and performance tuning across modern stacks. I've worked with enterprise environments where failure isn't an option, so reliability, security, and precision are non-negotiable. I'm obsessed with clean architecture, efficient pipelines, and automation that prevents headaches — not causes them. With 40+ industry certifications and a forward-looking focus on AI and Web3, I build systems designed for today's demands and tomorrow's innovation. Simply put, I deliver data solutions built for impact, built for scale, and built for the future.",
  },
  tools: {
    title: "Here are some of the tools and technologies I use on a daily basis",
  },
  education: {
    title: "Education",
    subtitle: "Academic foundation in Computer Engineering with strong focus on data systems",
    graduated: "Graduated",
    institutions: {
      maranatha: {
        name: "Maranatha Christian University",
        degree: "Bachelor of Engineering (B.E.), Computer Engineering",
        highlights: [
          "GPA: 3.83",
          "Relevant coursework: Databases, Operating Systems, Computer Networks",
        ],
      },
      yosuka: {
        name: "Yos Sudarso Senior High School - Karawang",
        degree: "Mathematics & Science Major",
        status: "High School Diploma",
      },
      akademicrypto: {
        name: "Akademi Crypto - Tangerang",
        degree: "Non-degree Program in Web3 and Blockchain",
        status: "Mar 2024 - Present",
        highlights: [
          "Focused on Web3, Blockchain Fundamentals, and Decentralized Technologies",
          "Active learning in crypto economics, smart contracts, and DeFi ecosystems",
        ],
      },
      tradewithsuli: {
        name: "TradeWithSuli - Jakarta",
        degree: "Non-degree Program in Financial Trading and Market Analysis",
        status: "Sep 2025 - Present",
        highlights: [
          "Focused on cryptocurrency trading using both fundamental and technical analysis",
          "Developing practical trading strategies and market evaluation skills through community learning",
        ],
      },
    },
  },
  experience: {
    title: "Experience",
    subtitle: "Cloud infrastructure automation, plus enterprise data engineering and technical consulting across various industries",
  },
  organizational: {
    title: "Organizational & Community",
    subtitle: "Leadership roles and active participation in professional and community organizations",
    activities: [
      {
        title: "University Leadership",
        organization: "Maranatha Christian University",
        role: "Head of Digital Computer Lab",
        dates: "Apr 2021 – Apr 2023",
        description: "Led lab, managed projects and student mentorship.",
      },
      {
        title: "Crypto Communities",
        organization: "Akademi Crypto, TradeWithSuli, Coin Kami",
        role: "Active Member",
        dates: "Feb 2023 - Present",
        description: "Active participant and lifelong learner in Web3 and crypto communities.",
      },
      {
        title: "Connect Group and Multimedia Ministry",
        organization: "Rose of Sharon Church",
        role: "Active Member",
        dates: "Aug 2015 - Present",
        description: "Actively involved in the church community through Connect Group fellowship and serving in the Multimedia Ministry, supporting worship services and creative media production.",
      },
    ],
  },
  events: {
    title: "Events & Gallery",
    subtitle: "Photos and highlights from events, conferences, seminars, and professional activities",
    noImages: "No Events Yet",
    maintenance: "Under Maintenance",
    maintenanceDesc: "No events have been added yet. Check back soon for updates!",
  },
  portfolio: {
    title: "Portfolio",
    subtitle: "Selected projects showcasing web development and data engineering work",
    webPortfolioTitle: "Web Portfolio",
    dataPortfolioTitle: "Data Engineering Portfolio",
    viewLive: "View Live",
    viewDetails: "View Details",
    explore: "Explore",
    showMore: "Show More",
    showLess: "Show Less",
    downloadPdf: "Download Portfolio as PDF",
    generatingPdf: "Generating PDF...",
    selectProjects: "Select Projects",
    selectAll: "Select All",
    cancel: "Cancel",
    downloadSelected: "Download",
    webProjects: [
      {
        title: "Mapan Furniture",
        description: "Maju Mapan is a modern furniture brand that blends elegant design with sustainability. Each piece is handcrafted by local artisans using eco-friendly materials — bringing comfort, balance, and warmth into every living space.",
      },
      {
        title: "Tcuber Store",
        description: "Tcuber Store is a trusted online game top-up platform in Indonesia, providing fast, secure, and affordable digital credits for popular games like Mobile Legends, Free Fire, Roblox, Genshin Impact, Clash of Clans, and PUBG Mobile. We offer various payment methods and responsive support to ensure a smooth gaming experience.",
      },
    ],
    dataProjects: [
      {
        title: "Penguin Data Analysis with AI",
        description: "Interactive data exploration tool powered by AI. Analyze penguin species data with natural language questions and visualize insights through dynamic charts. Built with React, Recharts, and Lovable AI.",
      },
    ],
    penguinExplorer: {
      title: "Ask about Penguins",
      selectQuestion: "What would you like to know?",
      submit: "Submit",
      analyzing: "Analyzing...",
      thinking: "Thinking...",
      errorLoading: "Error loading penguin data",
      errorAnalyzing: "Error analyzing data",
      rateLimitError: "Rate limit exceeded. Please try again later.",
      paymentError: "Payment required. Please add credits to your Lovable AI workspace.",
      speciesDistribution: "Species Distribution",
      billVsBody: "Bill Length vs Body Mass",
      dataTable: "Data Preview",
      questions: [
        "Which penguins have the longest bill length?",
        "Where do the heaviest penguins live?",
        "Which penguins have the shortest flippers?",
      ],
    },
  },
  portfolioDetail: {
    majuAbout: "Maju Mapan is a modern furniture brand website that blends elegant design with sustainability. Built with React and modern web technologies, this project showcases handcrafted furniture pieces by local artisans using eco-friendly materials. The website brings comfort, balance, and warmth into every living space through beautiful design and user experience.",
    majuFeatures: [
      "Responsive design optimized for all devices",
      "Beautiful UI with smooth scroll animations",
      "Interactive product showcase gallery",
      "Contact form with email integration",
      "Fast loading with optimized images",
      "Modern design system with Tailwind CSS",
    ],
    majuChallenges: [
      "Creating an elegant and modern design system that reflects the brand identity",
      "Optimizing large furniture images for fast loading without quality loss",
      "Implementing smooth scroll animations and transitions",
      "Building a responsive gallery that works on all screen sizes",
    ],
    tcuberAbout: "Tcuber Store is a comprehensive online gaming top-up platform in Indonesia. This application provides fast, secure, and affordable digital credits for popular games including Mobile Legends, Free Fire, Roblox, Genshin Impact, Clash of Clans, and PUBG Mobile. Built with modern web technologies and integrated with secure payment systems.",
    tcuberFeatures: [
      "Secure payment gateway integration",
      "Fast digital credit delivery system",
      "Support for multiple popular games",
      "Real-time transaction tracking",
      "Responsive customer support system",
      "User-friendly interface with intuitive navigation",
    ],
    tcuberChallenges: [
      "Integrating multiple payment gateways securely",
      "Building a reliable real-time transaction system",
      "Creating an intuitive user experience for seamless purchases",
      "Implementing proper security measures for payment data",
    ],
    penguinAbout: "An interactive data exploration tool powered by AI that allows users to analyze penguin species data through natural language questions. Built with React, Recharts, and Lovable AI, this project demonstrates the power of combining data visualization with artificial intelligence to make data analysis accessible to everyone.",
    penguinFeatures: [
      "Natural language query interface powered by AI",
      "Dynamic data visualization with interactive charts",
      "Real-time AI-powered insights and analysis",
      "Interactive charts built with Recharts library",
      "Responsive design for all devices",
      "CSV data parsing and processing",
    ],
    penguinChallenges: [
      "Integrating AI for accurate natural language processing",
      "Creating responsive and interactive data visualizations",
      "Handling large datasets efficiently in the browser",
      "Designing an intuitive interface for data exploration",
    ],
  },
  skills: {
    title: "Skills",
    subtitle: "Cloud infrastructure, automation, and CI/CD, on a foundation of enterprise data engineering",
    categories: {
      cloud: "Cloud & Infrastructure",
      iac: "IaC & GitOps",
      cicd: "CI/CD",
      containers: "Containers & Observability",
      security: "Security & Networking",
      databases: "Databases",
      etl: "ETL & Integration",
      programming: "Programming",
      soft: "Soft Skills",
    },
  },
  certificates: {
    title: "Dataiku Certificates",
    subtitle: "Professional certifications in data science, machine learning, and AI from Dataiku",
    clickToView: "Click to view full certificate",
    download: "Download",
    verify: "Verify",
    preview: "Certificate Preview",
  },
  awards: {
    title: "Awards & Certifications",
    subtitle: "Professional certifications across data platforms, cloud infrastructure, and AI technologies",
    view: "View",
  },
  contact: {
    title: "Get In Touch",
    subtitle: "Open to opportunities, collaborations, and speaking requests",
    info: "Contact Information",
    email: "Email",
    phone: "Phone",
    social: "Social Media",
    sendMessage: "Send a Message",
    name: "Name",
    namePlaceholder: "Masukkan nama",
    emailPlaceholder: "Masukkan email",
    message: "Message",
    messagePlaceholder: "Masukkan pesan",
    send: "Send Message",
    copyright: "© 2025 Widyo Tri Cahya Utomo. All rights reserved.",
  },
  whatsapp: {
    title: "Let's Connect",
    subtitle: "Choose how you'd like to reach out",
    chatbot: "Chat with AI Assistant",
    whatsapp: "Message on WhatsApp",
    defaultMessage: "Hi Widyo! I'd like to connect with you.",
  },
  chatbot: {
    title: "AI Assistant",
    welcome: "Hello! I'm Widyo's AI assistant. I can answer questions about his experience, skills, and projects. How can I help you?",
    placeholder: "Type your message...",
    error: "Sorry, I encountered an error. Please try again.",
  },
};
